import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments';
import { PrismHeaders } from '../../enums';
import { BehaviorSubject } from 'rxjs';
import { Response } from '../../models/http-response';
import { DialogService } from './dialog.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  private _downloadData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private _zipProcessing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient, private dialogService: DialogService) {
  }

  get downloadData$() {
    return this._downloadData.asObservable();
  }

  set downloadData(downloadData) {
    this._downloadData.next(downloadData);
  }

  get zipProcessing$() {
    return this._zipProcessing.asObservable();
  }

  getDownloadData(jobId) {
    const headers = new HttpHeaders()
      .append(PrismHeaders.QueryData, JSON.stringify({prefix: jobId}));

    return this.http.get(`${environment.apiBaseUrl}/processor2-get-download-data`, {headers});
  }

  sanitizeAddress(address) {
    const disallowedChars = ['/', '@', '|', '<', '>', ':', '"', '\\', '?', '*', '.'];

    return address
      .split('')
      .map(char => {
        if (disallowedChars.includes(char)) {
          return '_';
        } else {
          return char;
        }
      })
      .join('');
  }

  sendDownloadRequest(address, prefix, filePaths, batchNum, downloadAll = false, fromDialog = false) {
    if (fromDialog) {
      this.dialogService.closeDialog();
    }
    address = this.sanitizeAddress(address);
    this._zipProcessing.next(true);
    const outputName = downloadAll
      ? `${prefix}_${address}_(FULL)`
      : `${prefix}_${address}`;

    if (downloadAll) {
      const filePathObjects = [];

      filePaths.forEach((batchEntry, i) => {
        batchEntry[1].forEach(batch => {
          const {path} = batch;
          let {name} = batch;

          if (!name.includes('.')) {
            name = 'brief.pdf';
          }
          filePathObjects.push({
            path,
            name: `${outputName}/Batch-${i + 1}/${name}`
          });
        });
      });

      const body = {
        outputName,
        files: filePathObjects
      };

      return this.http.post(`${environment.assetServiceUrl}`, body)
        .toPromise()
        .then(({data: {signedUrl, bundleZipSizeBytes}}: Response) => {
          window.open(signedUrl, '_parent');
          this._zipProcessing.next(false);
        })
        .catch(e => {
          console.error(e);
          this._zipProcessing.next(false);
        });

    } else {
      const filePathObjects = filePaths.map(({path, name}) => {
          if (!name.includes('.')) {
            name = 'brief.pdf';
          }
        return {
          path,
          name: `${outputName}/Batch-${batchNum}/${name}`
        };
        }
      );

      const body = {
        outputName,
        files: filePathObjects
      };

      return this.http.post(`${environment.assetServiceUrl}`, body)
        .toPromise()
        .then(({data: {signedUrl, bundleZipSizeBytes}}: Response) => {
          window.open(signedUrl, '_parent');
          this._zipProcessing.next(false);
        })
        .catch(e => {
          console.error(e);
          this._zipProcessing.next(false);
        });
    }
  }

}
